import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getAmortizationAvailableColumns } from './api';

export const path = '/calculator-tariff/amortization/list';

const PageAmortizations: React.FC = (props) => {
  const Amortizations = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getAmortizationAvailableColumns,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <Amortizations {...props} />;
};

export default PageAmortizations;
